import "../../scss/pages/desktop-applications.scss";

document.addEventListener("DOMContentLoaded", function () {
	const buttonAppStoreList = document.querySelectorAll('.desktopApplications-page .btn-download');
	const buttonAppVersionsList = document.querySelectorAll('.desktopApplications-page .btn-download-versions');
	
	buttonAppVersionsList.forEach((buttonAppVersions) => {
		buttonAppVersions.addEventListener('click', () => {
			import('../components/modal')
				.then((module) => {
					const modalModule = new module.Modal();
					const params = {
						cardsVersions: JSON.parse(buttonAppVersions.dataset.versions)
					}
					modalModule.openModal('modal-desktop-app-versions', buttonAppVersions.dataset.id, 'modal/modal-desktop-app-versions', params);
				})
				.catch((error) => {
					console.error("Error loading module:", error);
				});
		})
	});
	
	buttonAppStoreList.forEach((buttonAppStore) => {
		buttonAppStore.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'desktopAppPage', buttonAppStore.dataset.tag]);
			/* eslint-enable */
		})
	});
});